import React, { Component } from "react";

// Prevents an unexpected render error (e.g. an unusual bill data shape for a
// particular account) from blanking the entire page. Without this, an uncaught
// exception unmounts the whole React tree and the user is left staring at a
// white screen with no message and no way to recover.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // Surface the real error in the console for debugging instead of swallowing
    // it silently behind a blank page.
    console.error("ErrorBoundary caught an error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <h4 className="font-bold">Sorry, we couldn't display this bill.</h4>
            <p>
              Something went wrong while loading this statement. Please try again
              later or contact GWA support for assistance.
            </p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
